"use strict";

import { initMenu } from '../components/menu.js';
import { initBanner } from '../components/banner.js';
import { initFooter } from '../components/footer.js';
import { initGuestConfirmationForm } from '../components/guest-confirmation-form.js';

const lieux = [
  {
    id: 'mapMairie',
    coords: [45.7666427, 4.8794883],
    zoom: 15,
    popupText: 'Mairie de Villeurbanne'
  },
  {
    id: 'mapEglise',
    coords: [45.7450426, 4.8186183],
    zoom: 15,
    popupText: 'Église Sainte Blandine'
  },
  {
    id: 'mapCeremonie',
    coords: [45.9294513, 4.7387234],
    zoom: 18,
    popupText: 'Domaine le Vauzel'
  }
];

function initMap(containerId, coords, zoomLevel, popupText) {
  const map = L.map(containerId, {
    center: coords.slice(0, 2),
    zoom: zoomLevel,
    scrollWheelZoom: false
  });

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }).addTo(map);

  L.marker(coords.slice(0, 2)).addTo(map)
    .bindPopup(popupText)
    .openPopup();

  return map;
}

export function initWhenWhere() {
  console.log("Initialisation de la page initWhenWhere");
  initBanner();
  initMenu();
  lieux.forEach(lieu => {
    initMap(lieu.id, lieu.coords, lieu.zoom, lieu.popupText);
  });
  initGuestConfirmationForm();
  initFooter();
}

module.exports = { initWhenWhere };
